import React, { Fragment, useEffect, useRef, useState } from "react";
import debounce from 'lodash/debounce';
import { Button, FormGroup, Label } from 'reactstrap';
import Select, { components } from "react-select";
import { codeWithColourAutoSuggestion } from "../../../../../services/manage-product/productService";

const AvailableColour = (props) => {
    const { getValues, setValue, trigger, errors } = props;

    const [availableInColourOptions, setAvailableInColourOptions] = useState([]);
    const [pageAvailableInColour, setPageAvailableInColour] = useState(1);
    const [hasMoreAvailableInColour, setHasMoreAvailableInColour] = useState(true);
    const [loadingAvailableInColour, setLoadingAvailableInColour] = useState(false);
    const [queryAvailableInColour, setQueryAvailableInColour] = useState('');

    // Fetch functions (copy from general.jsx, but use your API import)
    const fetchAvailableInColourOptions = async (inputValue, page) => {
        if (loadingAvailableInColour || !hasMoreAvailableInColour) return;
        setLoadingAvailableInColour(true);
        try {
            let searchData = { 
                q: inputValue,
                page: page,
                page_size: 10,
                exclude_ids: getValues("available_colours").map(c => c.id)  // Exclude already selected colours
            };
            const response = await codeWithColourAutoSuggestion(searchData);
            const newOptions = response.response;
            setAvailableInColourOptions(prevOptions => (page === 1 ? newOptions : [...prevOptions, ...newOptions]));
            setHasMoreAvailableInColour(newOptions.length === 10);
            setPageAvailableInColour(page + 1);
            setLoadingAvailableInColour(false);
        } catch (error) {
            setLoadingAvailableInColour(false);
            console.error('Error fetching availableInColour options:', error);
        }
    };
    
    // Debounced fetch
    const debouncedFetchAvailableInColourOptions = React.useCallback(debounce((inputValue, page) => fetchAvailableInColourOptions(inputValue, page), 500), []);

    // Input change handlers
    const handleInputChangeAvailableInColour = (inputValue) => {
        setPageAvailableInColour(1);
        setHasMoreAvailableInColour(true);
        setQueryAvailableInColour(inputValue);
        debouncedFetchAvailableInColourOptions(inputValue, 1);
    };

    
    // Infinite scroll handlers
    const handleMenuScrollToBottomAvailableInColour = () => {
        if (hasMoreAvailableInColour) {
            fetchAvailableInColourOptions(queryAvailableInColour, pageAvailableInColour);
        }
    };
    
    // Menu open handlers
    const handleMenuOpenAvailableInColour = () => {
        fetchAvailableInColourOptions(queryAvailableInColour, 1);
    };


    return (
        <FormGroup>
            <Label className="form-label">Also Available in Colour</Label>
            <Select
                placeholder="Select Colours"
                isMulti
                options={availableInColourOptions}
                getOptionValue={option => option.id}
                getOptionLabel={option => option.name}
                value={(getValues("available_colours") || [])}
                onChange={selected => { setValue("available_colours", selected); trigger("available_colours"); }}
                onInputChange={handleInputChangeAvailableInColour}
                onMenuScrollToBottom={handleMenuScrollToBottomAvailableInColour}
                onMenuOpen={handleMenuOpenAvailableInColour}
                isLoading={loadingAvailableInColour}
                className={errors.available_colours ? "is-invalid" : ""}
                noOptionsMessage={() => 'No product found'}
                isClearable={true}
                components={{
                    IndicatorSeparator: () => null,
                    DropdownIndicator: (_props) => {
                        return null;
                        // return getValues("available_colours").length > 0 ? null : <components.DropdownIndicator {..._props} />;
                    }
                }}
            />
            <div className="invalid-feedback">{errors.available_colours?.message}</div>
        </FormGroup>
    );
};

export default AvailableColour;
